// extracted by css-extract-rspack-plugin
export default {"pageWrapper":"pageWrapper-OqrVt9"};